import React from "react";
import { FaEnvelope, FaPhoneAlt, FaQuestionCircle, FaInfoCircle, FaShieldAlt } from "react-icons/fa";
import { Footer } from "../../components";

const Support: React.FC = () => {
    return (
        <div className="bg-green-900 min-h-screen flex flex-col text-white font-sans">
            {/* HEADER */}
            <section className="relative py-14 px-6 text-center overflow-hidden">
                <h1 className="text-4xl md:text-6xl font-extrabold text-yellow-400 mb-4">
                    Support Mediiq
                </h1>
                <p className="max-w-3xl mx-auto text-gray-200 text-lg leading-relaxed">
                    Nous sommes là pour vous aider. Retrouvez ci-dessous toutes les informations
                    de support et d’assistance concernant l'application{" "}
                    <span className="text-green-400 font-semibold">Mediiq</span>.
                </p>

                <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-green-900/90 z-0" />
            </section>

            <section className="flex-grow px-6 md:px-16 py-10">
                <div className="grid lg:grid-cols-3 gap-8">
                    {/* CONTACT BOX */}
                    <div className="bg-white text-green-900 rounded-2xl shadow-xl p-6 flex flex-col gap-4">
                        <div className="flex items-center gap-3">
                            <FaEnvelope className="text-3xl text-green-700" />
                            <h2 className="text-2xl font-bold">Contact Assistance</h2>
                        </div>
                        <p className="text-green-700">
                            Pour toute question liée à l’application, un problème technique ou une demande d’aide,
                            contactez notre équipe support :
                        </p>

                        <p className="font-semibold">📧 Email Support :</p>
                        <a
                            href="mailto:support@mediiq.app"
                            className="text-green-700 underline hover:text-green-800"
                        >
                            support@mediiq.app
                        </a>

                        <p className="font-semibold mt-2">📞 Téléphone :</p>
                        <a
                            href="tel:+2250705704553"
                            className="text-green-700 underline hover:text-green-800"
                        >
                            +225 07 05 70 45 53
                        </a>
                    </div>

                    {/* ABOUT MEDIIQ BOX */}
                    <div className="bg-white text-green-900 rounded-2xl shadow-xl p-6 flex flex-col gap-4">
                        <div className="flex items-center gap-3">
                            <FaInfoCircle className="text-3xl text-green-700" />
                            <h2 className="text-2xl font-bold">À propos de Mediiq</h2>
                        </div>

                        <p className="text-green-700 leading-relaxed">
                            Mediiq est une <strong>plateforme numérique</strong> qui connecte les utilisateurs
                            à des <strong>pharmacies partenaires indépendantes</strong>.
                            <br /><br />
                            Mediiq ne vend pas de médicaments, ne prépare pas d’ordonnances et ne fournit
                            aucun service médical. Toutes les prestations et ventes sont assurées
                            exclusivement par les pharmacies partenaires dûment autorisées.
                        </p>

                        <p className="text-sm italic text-green-600">
                            Loven Software Development SARL U est l’éditeur de la plateforme Mediiq
                            et gère uniquement l’infrastructure technique, le support utilisateur
                            et la mise en relation.
                        </p>
                    </div>

                    {/* FAQ + POLICIES */}
                    <div className="bg-white text-green-900 rounded-2xl shadow-xl p-6 flex flex-col gap-4">
                        <div className="flex items-center gap-3">
                            <FaQuestionCircle className="text-3xl text-green-700" />
                            <h2 className="text-2xl font-bold">Aide & Documentation</h2>
                        </div>

                        <ul className="space-y-3 text-green-700">
                            <li className="flex items-center gap-2">
                                <FaShieldAlt className="text-green-700" />
                                <a
                                    href="/privacy"
                                    className="underline hover:text-green-800"
                                >
                                    Politique de confidentialité
                                </a>
                            </li>

                            <li className="flex items-center gap-2">
                                <FaShieldAlt className="text-green-700" />
                                <a
                                    href="/terms"
                                    className="underline hover:text-green-800"
                                >
                                    Conditions d’utilisation
                                </a>
                            </li>

                            <li className="flex items-center gap-2">
                                <FaShieldAlt className="text-green-700" />
                                <a
                                    href="/faq"
                                    className="underline hover:text-green-800"
                                >
                                    FAQ - Questions fréquentes
                                </a>
                            </li>

                            {/* NEW: Pharmacy legal onboarding */}
                            <li className="flex items-center gap-2">
                                <FaShieldAlt className="text-green-700" />
                                <a href="/partners/legal" className="underline hover:text-green-800">
                                    Conditions légales pour pharmacies partenaires
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>

                {/* PLATFORM CLARIFICATION BANNER */}
                <div className="mt-12 bg-green-800 text-yellow-300 p-6 rounded-2xl text-center shadow-lg">
                    <p className="font-semibold text-lg">
                        ⚠️ Mediiq est une plateforme de mise en relation.
                        Les pharmacies partenaires sont les seules responsables de la préparation,
                        validation et délivrance des médicaments.
                    </p>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Support;
